var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel"},[_c('img',{attrs:{"src":require('@/assets/images/panel_graphics/intro.png'),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }